import { ModuleRegisterContext, ModuleRegisterFn } from "@/module-register"

const registerPlanShoppingModule: ModuleRegisterFn = (_context: ModuleRegisterContext) => {
  console.log("Plan Shopping module registered 💪!")
}

export default registerPlanShoppingModule
